// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CodepenOutlinedSvg from "@fishx/icons-svg/es/asn/CodepenOutlined";
import FishxIcon from '../components/FishxIcon';

var CodepenOutlined = function CodepenOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: CodepenOutlinedSvg
  }));
};

CodepenOutlined.displayName = 'CodepenOutlined';
export default React.forwardRef(CodepenOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/CodepenOutlined.js
// module id = 2277
// module chunks = 0